<template>
    <div style="padding-bottom: 60px">
        <order-create-view
                :show_create_order="show_create_order"
                v-on:update:show_create_order="show_create_order = $event"
        ></order-create-view>

        <request-create-view
                :show_create_request="show_create_request"
                :porting_order_id="selected_order_id"
                :supplement_dd_only="supplement_dd_only"
                v-on:update:show_create_request="show_create_request = $event"
        ></request-create-view>

        <comment-add-modal
                :show_add_comment="show_add_comment"
                :order="current_order"
                v-on:update:show_add_comment="show_add_comment = $event"
        ></comment-add-modal>

        <order-item-view
                :order="current_order"
                :show_current_order="show_current_order"
                v-on:update:show_current_order="show_current_order = $event"
        ></order-item-view>

        <order-status-change-modal
                v-if="user.is_staff"
                type="open"
                :order="current_order"
                :order_status="order_status"
                :show_order_status_change="show_order_status_change"
                v-on:update:show_order_status_change="show_order_status_change = $event"
        >
        </order-status-change-modal>

        <md-card
                style="margin: auto; margin-top: 30px"
                class="md-layout-item md-large-size-95 md-size-95 md-small-size-95">
            <md-toolbar>
                <div class="md-title md-layout md-gutter" style="width: inherit">
                    <div class="md-layout-item md-alignment-center-left"
                         style="text-align: initial; padding-left: initial">All orders
                    </div>
                    <div class="md-layout md-alignment-center-right">
                        <el-button
                                class="md-layout-item md-size-35 md-large-size-35 md-small-size-35"
                                v-if="!user.is_staff"
                                style="font-weight: 500"
                                @click="createOrder"
                                icon="el-icon-plus"
                                @click.stop
                                size="medium"
                                type="warning">Create Order
                        </el-button>
                    </div>
                </div>
            </md-toolbar>

            <md-card-content>
                <div class="md-layout md-gutter md-alignment-center-center md-size-20" style="margin-bottom: 10px;">
                    <div class="md-layout-item md-alignment-center-left" style="text-align: initial">
                        <el-button
                                style="font-weight: 500; background-color: rgb(244, 244, 244)"
                                :disabled="(Object.keys(open_orders_filter).length === Object.keys(default_filter).length) && open_orders_filter['status__in'] === default_filter['status__in']"
                                @click="clearFilter">
                            Reset filters
                        </el-button>
                    </div>
                    <div class="md-layout md-alignment-center-right md-size-80" style="padding-right: 20px">
                        <el-input
                                placeholder="Input an order name or order number to search by"
                                clearable
                                @clear="onClearSearch"
                                v-model="open_orders_search"
                                class="input-with-select">
                            <el-button
                                    :disabled="!open_orders_search"
                                    @click="onSearch()"
                                    style="background-color: rgb(244, 244, 244)"
                                    slot="append"
                                    icon="el-icon-search"></el-button>
                        </el-input>
                    </div>
                </div>
                <el-table :data="orders"
                          ref="ordersTable"
                          :header-cell-style="tableHeaderStyle"
                          stripe
                          row-key="id"
                          @filter-change="applyFilter"
                          border
                          @row-click="onOrderSelect"
                          style="width: 100%">
                    <el-table-column
                            sortable
                            width="150"
                            prop="porting_order_number"
                            label="Order Number">
                    </el-table-column>
                    <el-table-column
                            sortable
                            width="120"
                            prop="user_id.username"
                            label="Requestor">
                    </el-table-column>
                    <el-table-column
                            sortable
                            prop="name"
                            label="Name">
                    </el-table-column>
                    <el-table-column
                            sortable
                            class-name="entity_id__in"
                            column-key="entity_id__in"
                            filter-placement="bottom-end"
                            :filter-multiple="true"
                            :filters="entities.map(obj => ({text: obj.name, value: obj.id}))"
                            prop="entity_id.name"
                            width="260"
                            label="Old Network Service Provider">
                    </el-table-column>
                    <el-table-column
                            sortable
                            width="250"
                            prop="new_entity"
                            label="New Network Service Provider">
                    </el-table-column>
                    <el-table-column
                            sortable
                            :sort-method="focDateSort"
                            prop="foc_date"
                            :formatter="foc_date_formatter"
                            width="110"
                            label="Port Date">
                    </el-table-column>
                    <el-table-column
                            sortable
                            width="135"
                            :formatter="created_date_formatter"
                            prop="date_created"
                            label="Date Created">
                    </el-table-column>
                    <el-table-column
                            sortable
                            width="105"
                            class-name="status__in"
                            column-key="status__in"
                            filter-placement="bottom-end"
                            :filter-multiple="true"
                            :filters="[
                                    { text: 'Submitted', value: 'Submitted' },
                                    { text: 'FOCDateApproved', value: 'FOCDateApproved' },
                                    { text: 'Rejected', value: 'Rejected' },
                                    { text: 'PendingCancellation', value: 'PendingCancellation' },
                                 ]"
                            prop="status"
                            label="Status">
                    </el-table-column>
                    <el-table-column
                            width="180"
                            label="Actions">
                        <template scope="props">
                            <template v-if="user.is_staff">
                                <el-button v-if="props.row.status === 'Submitted'"
                                           icon="el-icon-check"
                                           @click="updateOrderStatus(props.row, 'FOCDateApproved')"
                                           @click.stop
                                           size="mini"
                                           type="text"
                                           class="action-button button-success">
                                    Approve Order
                                </el-button>
                                <el-button v-if="props.row.status === 'Submitted'"
                                           icon="el-icon-close"
                                           @click="updateOrderStatus(props.row, 'Rejected')"
                                           @click.stop
                                           size="mini"
                                           type="text"
                                           class="action-button button-failure">
                                    Reject Order
                                </el-button>
                                <el-button v-if="props.row.status === 'FOCDateApproved'"
                                           icon="el-icon-check"
                                           @click="updateOrderStatus(props.row, 'Completed')"
                                           @click.stop
                                           size="mini"
                                           type="text"
                                           class="action-button button-success">
                                    Mark Completed
                                </el-button>
                                <el-button v-if="props.row.status === 'FOCDateApproved'"
                                           icon="el-icon-close"
                                           @click="updateOrderStatus(props.row, 'Failed')"
                                           @click.stop
                                           size="mini"
                                           type="text"
                                           class="action-button button-failure">
                                    Mark Failed
                                </el-button>
                                <el-button v-if="props.row.status === 'PendingCancellation'"
                                           icon="el-icon-close"
                                           @click="updateOrderStatus(props.row, 'Cancelled')"
                                           @click.stop
                                           size="mini"
                                           type="text"
                                           class="action-button button-failure">
                                    Mark Cancelled
                                </el-button>
                                <el-button v-if="!(['Completed', 'Failed', 'Cancelled']).includes(props.row.status)"
                                           icon="el-icon-notebook-2"
                                           @click="addOrderComment(props.row)"
                                           @click.stop
                                           size="mini"
                                           type="text"
                                           class="action-button">
                                    Add Comment
                                </el-button>
                            </template>
                            <template v-if="!user.is_staff">
                                <el-button v-if="props.row.status === 'Submitted' || props.row.status === 'Rejected'"
                                           icon="el-icon-edit"
                                           @click="supplementOrder(props.row.id)"
                                           @click.stop
                                           size="mini"
                                           type="text"
                                           class="action-button">
                                    Supplement Order
                                </el-button>
                                <el-button v-if="props.row.status === 'Submitted' || props.row.status === 'Rejected'"
                                           icon="el-icon-close"
                                           @click="requestCancellation(props.row.id)"
                                           @click.stop
                                           size="mini"
                                           type="text"
                                           class="action-button button-failure">
                                    Request Cancellation
                                </el-button>
                                <el-button v-if="props.row.status === 'FOCDateApproved' && isSubmitAllowed(props.row)"
                                           icon="el-icon-edit"
                                           @click="supplementOrderDD(props.row.id)"
                                           @click.stop
                                           size="mini"
                                           type="text"
                                           class="action-button">
                                    Supplement Order Requested Port Date
                                </el-button>
                                <el-button v-if="props.row.status === 'FOCDateApproved' && isSubmitAllowed(props.row)"
                                           icon="el-icon-close"
                                           @click="requestCancellation(props.row.id)"
                                           @click.stop
                                           size="mini"
                                           type="text"
                                           class="action-button button-failure">
                                    Request Cancellation
                                </el-button>
                                <el-button v-if="!(['Completed', 'Failed', 'Cancelled']).includes(props.row.status)"
                                           icon="el-icon-notebook-2"
                                           @click="addOrderComment(props.row)"
                                           @click.stop
                                           plain
                                           size="mini"
                                           type="text"
                                           class="action-button">
                                    Add Comment
                                </el-button>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="orders.length !== 0">
                    <el-pagination
                            style="padding-top: 20px"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="open_orders_current_page"
                            :page-sizes="[10, 25, 50, 100]"
                            :page-size="open_orders_current_page_size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="order_total_results">
                    </el-pagination>
                </template>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import moment from "moment";
    import OrderItemView from './OrderItemView'
    import OrderCreateView from "@/components/common/OrderCreateView";
    import RequestCreateView from "@/components/common/RequestCreateView";
    import OrderStatusChangeModal from "@/components/common/OrderStatusChangeModal";
    import CommentAddModal from "@/components/common/CommentAddModal";
    import {HEADER_NORMAL_WEIGHT, HEADER_HIGHLIGHT_WEIGHT} from '@/components/utils/constants'

    export default {
        name: "OpenOrderList",
        components: {OrderStatusChangeModal, OrderCreateView, OrderItemView, RequestCreateView, CommentAddModal},
        data() {
            return {
                current_order: {
                    "id": null,
                    "date_created": "",
                    "entity_id": {
                        "id": null,
                        "name": ""
                    },
                    "porting_order_number": "",
                    "name": "",
                    "status": "",
                    "foc_date": null,
                    "comments": null
                },
                current_request: {
                    billing_telephone_number: "",
                    customer_street1: "",
                    customer_street2: "",
                    customer_account_number: "",
                    customer_city: "",
                    customer_name: "",
                    customer_state: "",
                    customer_zip: "",
                    loa_url: "",
                    loa_filename: "",
                    phone_numbers: "",
                    requested_foc_date: null,
                },
                show_current_order: false,
                show_create_order: false,
                show_create_request: false,
                supplement_dd_only: false,
                show_add_comment: false,
                show_order_status_change: false,
                selected_order_id: null,
                order_status: "",
                interval: null,
                default_filter: {'status__in': 'Submitted,FOCDateApproved,Rejected,PendingCancellation'}
            }
        },
        beforeDestroy() {
            clearInterval(this.interval);
        },
        watch: {
            show_notification: function (newVal) {
                if (newVal === true) {
                    this.$notify({
                        title: this.notification['type'].charAt(0).toUpperCase() + this.notification['type'].slice(1),
                        message: this.notification['text'],
                        type: this.notification['type'],
                        position: 'top-right',
                    });
                    this.$store.dispatch('orders/setShowNotification', false)
                }
            },
            executing_update: function (newVal, oldVal) {
                if (newVal.status === false && oldVal.status === true && this.notification.type === 'success') {
                    if (newVal.type === 'open') {
                        this.$store.dispatch('orders/getOrders', {
                                ...{
                                    page: this.open_orders_current_page,
                                    page_size: this.open_orders_current_page_size,
                                    search: this.open_orders_search,
                                }, ...this.open_orders_filter
                            }
                        )
                    }
                }
            },
        },
        created() {
            this.$store.dispatch('orders/setOpenOrdersFilter', {...this.default_filter})
            this.$store.dispatch('orders/setOpenOrdersSearch', '')
            this.$store.dispatch('orders/setOpenOrdersCurrentPage', 1)
            this.$store.dispatch('orders/setOpenOrdersCurrentPageSize', 50)
            this.$store.dispatch('orders/getOrders', {
                ...{
                    page: this.open_orders_current_page,
                    page_size: this.open_orders_current_page_size,
                    search: this.open_orders_search,
                }, ...this.open_orders_filter
            })
            this.$store.dispatch('entities/getEntities')
            this.interval = setInterval(function () {
                this.$store.dispatch('orders/getOrders', {
                        ...{
                            page: this.open_orders_current_page,
                            page_size: this.open_orders_current_page_size,
                            search: this.open_orders_search,
                        }, ...this.open_orders_filter
                    }
                )
            }.bind(this), 60000)
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                orders: state => state.orders.orders,
                open_orders_filter: state => state.orders.open_orders_filter,
                open_orders_search: state => state.orders.open_orders_search,
                open_orders_current_page: state => state.orders.open_orders_current_page,
                open_orders_current_page_size: state => state.orders.open_orders_current_page_size,
                executing_update: state => state.orders.executing_update,
                order_total_results: state => state.orders.total_results,
                notification: state => state.orders.notification,
                show_notification: state => state.orders.show_notification,
                entities: state => state.entities.entities
            }),
            open_orders_filter: {
                get() {
                    return this.$store.state.orders.open_orders_filter
                },
                set(value) {
                    return this.$store.dispatch('orders/setOpenOrdersFilter', value)
                }
            },
            open_orders_search: {
                get() {
                    return this.$store.state.orders.open_orders_search
                },
                set(value) {
                    return this.$store.dispatch('orders/setOpenOrdersSearch', value)
                }
            },
            open_orders_current_page: {
                get() {
                    return this.$store.state.orders.open_orders_current_page
                },
                set(value) {
                    return this.$store.dispatch('orders/setOpenOrdersCurrentPage', value)
                }
            },
            open_orders_current_page_size: {
                get() {
                    return this.$store.state.orders.open_orders_current_page_size
                },
                set(value) {
                    return this.$store.dispatch('orders/setOpenOrdersCurrentPageSize', value)
                }
            },

        },
        methods: {
            onOrderSelect(item) {
                if (item !== undefined) {
                    this.current_order = item || this.current_order
                    this.show_current_order = true
                }
            },
            onSearch() {
                this.$store.dispatch('orders/getOrders', {
                    ...{
                        page_size: this.open_orders_current_page_size,
                        search: this.open_orders_search
                    }, ...this.open_orders_filter
                })
            },
            onClearSearch() {
                this.$store.dispatch('orders/setOpenOrdersSearch', '')
                this.$store.dispatch('orders/getOrders', {
                    ...{
                        page_size: this.open_orders_current_page_size,
                        search: this.open_orders_search
                    },
                    ...this.open_orders_filter
                })
            },
            applyFilter(filter) {
                Object.keys(filter).forEach((key) => {
                    if (filter[key]) {
                        if (filter[key].length > 0) {
                            this.open_orders_filter[key] = filter[key].join(',')
                            let elem = document.querySelector(`.${key}`)
                            elem.style.fontWeight = HEADER_HIGHLIGHT_WEIGHT
                        } else {
                            let elem = document.querySelector(`.${key}`)
                            elem.style.fontWeight = HEADER_NORMAL_WEIGHT
                            delete this.open_orders_filter[key]
                        }
                    }
                })
                if (Object.keys(this.open_orders_filter).length === 0)
                    this.$store.dispatch('orders/setOpenOrdersFilter', { ...this.default_filter})

                this.$store.dispatch('orders/getOrders', {
                    ...this.open_orders_filter, ...{
                        page_size: this.open_orders_current_page_size,
                        search: this.open_orders_search
                    }
                })
            },
            createOrder() {
                this.show_create_order = true
            },
            updateOrderStatus(order, status) {
                this.show_order_status_change = true
                this.current_order = order
                this.order_status = status
            },
            markCompleted(id) {
                this.$confirm('This will permanently change order status to Completed. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('orders/patchOrder', {id: id, status: 'Completed', type: 'open'})
                }).catch(() => {
                });

            },
            markFailed(id) {
                this.$confirm('This will permanently change order status to Failed. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('orders/patchOrder', {id: id, status: 'Failed', type: 'open'})
                }).catch(() => {
                });
            },
            requestCancellation(id) {
                this.$confirm('This will cancel the request permanently. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('orders/patchOrder', {id: id, status: 'PendingCancellation', type: 'open'})
                }).catch(() => {
                });
            },
            supplementOrder(id) {
                this.selected_order_id = id;
                this.show_create_request = true;
                this.supplement_dd_only = false;
            },
            supplementOrderDD(id) {
                this.selected_order_id = id;
                this.show_create_request = true;
                this.supplement_dd_only = true;
            },
            addOrderComment(order) {
                this.current_order = order;
                this.show_add_comment = true;
            },
            isSubmitAllowed(row) {
                let hours = (new Date(row.foc_date) - Date.now()) / (1000 * 60 * 60)
                if (hours > 12) {
                    return true;
                }
                return false;
            },
            clearFilter() {
                Object.keys(this.open_orders_filter).forEach(function (key) {
                    if (this.open_orders_filter[key]) {
                        let elem = document.querySelector(`.${key}`)
                        elem.style.fontWeight = HEADER_NORMAL_WEIGHT
                    }
                }.bind(this))
                this.$refs.ordersTable.clearFilter();
                this.$store.dispatch('orders/setOpenOrdersFilter', { ...this.default_filter})
                this.$store.dispatch('orders/getOrders', {
                    ...{
                        page_size: this.open_orders_current_page_size,
                        search: this.open_orders_search
                    }, ...this.open_orders_filter
                })
            },
            handleSizeChange(val) {
                this.open_orders_current_page_size = val
                this.$store.dispatch('orders/getOrders', {
                    ...{
                        page: this.open_orders_current_page,
                        page_size: this.open_orders_current_page_size,
                        search: this.open_orders_search
                    }, ...this.open_orders_filter
                })
            },
            handleCurrentChange(val) {
                this.open_orders_current_page = val
                this.$store.dispatch('orders/getOrders', {
                    ...{
                        page: this.open_orders_current_page,
                        page_size: this.open_orders_current_page_size,
                        search: this.open_orders_search
                    }, ...this.open_orders_filter
                })
            },
            tableHeaderStyle({rowIndex}) {
                if (rowIndex === 0) {
                    return 'background-color: #f4f4f4;color: #475669; font-weight: 500'
                }
            },
            foc_date_formatter(row) {
                return (row.foc_date) ? moment(row.foc_date).format('YYYY-MM-DD') : '';
            },
            created_date_formatter(row) {
                return moment(row.date_created).format('YYYY-MM-DD');
            },
            focDateSort(a, b) {
                if (!a.foc_date && b.foc_date) return -1;
                if (a.foc_date && !b.foc_date) return 1;
                if (!a.foc_date && !b.foc_date) return 0;
                if (moment(a.foc_date) > moment(b.foc_date)) return 1;
                if (moment(a.foc_date) < moment(b.foc_date)) return -1;
                return 0;
            },
        }

    }
</script>

<style>
    .el-checkbox__label {
        font-weight: 500;
    }

    button {
        font-weight: 500;
    }

    button.el-button.action-button {
        margin-left: 0px;
        white-space: normal;
        word-break: keep-all;
        text-align: left;
        line-height: normal;
    }

    button.el-button.button-failure {
        color: #f56c6c;
    }

    button.el-button.button-failure:hover {
        color: #f78989;
    }

    button.el-button.button-success {
        color: #67c23a;
    }

    button.el-button.button-success:hover {
        color: #85ce61;
    }
</style>